module.exports = __webpack_public_path__ + "static/roman-electric-logo-a3591efb8f481ebfb261579b67a58432.png";